import { render, staticRenderFns } from "./CaseObservations.vue?vue&type=template&id=7df0c544&"
import script from "./CaseObservations.vue?vue&type=script&lang=js&"
export * from "./CaseObservations.vue?vue&type=script&lang=js&"
import style0 from "./CaseObservations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports